import React from 'react';
import styled from 'styled-components';
import { Loadable } from 'components/types';
import { theme, toRem } from 'design';
import { ButtonIcon } from '../Button';
import { Text } from '../Typography';
import ProgressBar, { ProgressBarProps } from './ProgressBar';

const BUTTON_SIZE_LARGE = theme.button.height.large;
const BUTTON_SIZE_SMALL = theme.button.height.small;
const BUTTON_MARGIN_LARGE = 22;
const BUTTON_MARGIN_SMALL = 16.5;

const Layout = styled.nav`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;

  @media (min-width: ${theme.breakpoint.med}px) {
    height: ${toRem(BUTTON_SIZE_LARGE)};
  }
`;

const BackButton = styled(ButtonIcon).attrs({
  appearance: 'white',
  icon: 'ArrowLeft',
  size: 'large',
})`
  position: relative;
  width: ${toRem(BUTTON_SIZE_SMALL)};
  height: ${toRem(BUTTON_SIZE_SMALL)};
  margin-right: ${toRem(BUTTON_MARGIN_SMALL)};

  svg {
    width: ${toRem(15.12)};
  }

  @media (min-width: ${theme.breakpoint.med}px) {
    width: ${toRem(BUTTON_SIZE_LARGE)};
    height: ${toRem(BUTTON_SIZE_LARGE)};
    margin-right: ${toRem(BUTTON_MARGIN_LARGE)};
    margin-left: -${toRem(BUTTON_SIZE_LARGE + BUTTON_MARGIN_LARGE)};

    svg {
      width: ${toRem(16.5)};
    }
  }
`;

const ProgressLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

const TitleLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  margin-bottom: ${toRem(11)};
`;

interface ProgressBarHeaderProps extends ProgressBarProps, Loadable {
  as?: any;
  disableBack?: boolean;
  hideBack?: boolean;
  label: string;
  onBack?: () => void;
  to?: string;
}

const ProgressBarHeader = ({ as, className, currentStep, disableBack, hideBack = false, isLoading, label, onBack, to, totalSteps }: ProgressBarHeaderProps) => (
  <Layout as={as} className={className} data-cy="account-setup-layout-progress">
    {!hideBack && <BackButton disabled={!to || disableBack} isLoading={isLoading} label="Previous Step" onClick={onBack} to={to} />}

    <ProgressLayout>
      <TitleLayout>
        <Text size="small" fontWeight="semibold">
          {label}
        </Text>
        <Text size="small" fontWeight="semibold">
          {`Step ${currentStep} of ${totalSteps}`}
        </Text>
      </TitleLayout>
      <ProgressBar totalSteps={totalSteps} currentStep={currentStep} />
    </ProgressLayout>
  </Layout>
);

export default ProgressBarHeader;
